/***
 * @file:æä»¶ä¸ä¼ ç»ä»¶
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UploadFile } from 'ng-zorro-antd/upload';

import { SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { DtMessageService } from '@ithinkdt/shared/message';

import { FormSearchService } from '../fetch/form-fetch.service';

@Component({
  selector: 'dt-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})

/**
 * ä¸ä¼ æä»¶
 */
export class FileUploadComponent implements OnInit {
  // æ¥åä¸ä¼ çæä»¶ç±»å  https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-accept
  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
  @Input() nzAccept: string;
  // ä¸ä¼ æä»¶è¯·æ±çapi
  @Input() nzAction = this.settingsSrv.userConfig['pages'] && this.settingsSrv.userConfig['pages'].upload;
  // æ¯æä¸ä¼ æä»¶å¤¹
  @Input() nzDirectory = false;
  // éå¶åæ¶ä¸ä¼ æä»¶æ°ï¼é»è®¤ä¸éå¶
  @Input() nzLimit = 0;
  // æ¥åä¸ä¼ çæä»¶å¤§å°ï¼åä½kb,é»è®¤100M
  @Input() nzSize = 102400;
  /** TODO å åç«¯è¿åçå­æ®µä¸ä¸è´å¯¼è´å¾çåºä¸æ¥ï¼åéæ¹è¿ */
  // éå¶æä»¶ç±»åï¼ä¾å¦ï¼image/png,image/jpeg,image/gif,image/bmp
  @Input() nzFileType: string;
  // ä¸ä¼ åè¡¨çåå»ºæ ·å¼ï¼æ¯æä¸ç§åºæ¬æ ·å¼ text, picture å picture-card
  @Input() nzListType: string;
  // æ¯å¦æ¯æå¤ä¸ªä¸ä¼ 
  @Input() nzMultiple = true;
  // æ¯å¦ç¦ç¨
  @Input() nzDisabled = false;

  // æ¨¡ææ¡æ é¢
  // @Input() type: 'iconModal' | 'bottomModal' | 'buttonList' | 'pictureCard' = 'iconModal';

  // æ¨¡ææ¡æ é¢
  @Input() title = 'fileUpload.upload';
  // æ¯å¦æ¾ç¤ºæé®ï¼ä¸ç¶åªæ¾ç¤ºå¾æ 
  @Input() showBtn = false;
  // æé®åç§°
  @Input() btnName = 'fileUpload.upload';
  // åªæ¾ç¤ºå¾æ æ¶å¾æ æ ·å¼:{'color': '#0061aa'}
  @Input() onlyIconStyle: object;
  // è¥ä¸æ³ç¨æé®ä¹ä¸æ³ç¨å¾æ èªå®ä¹æé®ï¼åè®¾ç½®æ­¤é¡¹ä¸ºtrue
  @Input() customContent = false;
  // æç¤ºæå­
  @Input() tips = 'fileUpload.supportDocuments';
  // å¾çä¸åè®¸éå¤ï¼è¥æéå¤çåå é¤
  @Input() deleteUniqFile = true;
  @Output() dtUpload = new EventEmitter<any>();

  isVisible = false;
  uploading = false;
  fileList: UploadFile[] = [];
  lang: any[];

  constructor(
    private msg: DtMessageService,
    private formSearchSrv: FormSearchService,
    private settingsSrv: SettingsService,
    private i18n: I18NService
  ) {
    this.lang = this.i18n.getLangs();
  }

  ngOnInit() {}

  /**
   * è·åæä»¶ååè°
   */

  beforeUpload = (file: UploadFile): boolean => {
    if (!this.nzMultiple) {
      this.fileList = [];
    }

    let canContact = true;
    // è¥ä¸åè®¸éå¤ï¼åå¤æ­å½åæ¯å¦å·²ä¸ä¼ ï¼æªä¸ä¼ åæ·»å 
    if (this.deleteUniqFile) {
      canContact = !this.fileList.some((item) => {
        return item.filename === file.filename && item.size === file.size && item.lastModified === file.lastModified;
      });
    }
    if (canContact) {
      this.fileList = this.fileList.concat(file);
    }

    return false;
  };

  /**
   * è¯·æ±æ¥å£ä¸ä¼ 
   */

  handleOk() {
    this.uploading = true;
    this.formSearchSrv.uploadData(this.nzAction, this.fileList).subscribe((res) => {
      if (res.status) {
        this.msg.success(this.i18n.interpret('fileUpload.uploadSuccess'));
        this.close();
      }
      this.dtUpload.emit(res);
      this.uploading = false;
    });
  }

  showModal(): void {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
    this.uploading = false;
    this.fileList = [];
  }
}
